<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_15872_11155)">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M1.46996 4.73584C1.95873 4.73584 2.35496 5.13207 2.35496 5.62084L2.35496 8.66822L16.6451 8.66823V5.62084C16.6451 5.13207 17.0413 4.73584 17.5301 4.73584C18.0189 4.73584 18.4151 5.13207 18.4151 5.62084L18.4151 13.3792C18.4151 13.8679 18.0189 14.2642 17.5301 14.2642C17.0413 14.2642 16.6451 13.8679 16.6451 13.3792V10.4382L2.35496 10.4382L2.35496 13.3792C2.35496 13.8679 1.95873 14.2642 1.46996 14.2642C0.981189 14.2642 0.584961 13.8679 0.584961 13.3792V5.62084C0.584961 5.13207 0.981191 4.73584 1.46996 4.73584Z"
      fill="currentColor" />
  </g>
  <defs>
    <clipPath id="clip0_15872_11155">
      <rect width="19" height="19" fill="white" />
    </clipPath>
  </defs>
</svg>